import ToastNotification from './ToastNotification';

export default ToastNotification;
